import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=b6cbcfe4"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6cbcfe4')) {
      api.createRecord('b6cbcfe4', component.options)
    } else {
      api.reload('b6cbcfe4', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=b6cbcfe4", function () {
      api.rerender('b6cbcfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/Icon.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/Icon.vue
// module id = 362
// module chunks = 0